import { apiHelper } from '@appfolio/js-utils-apm';
import { withEnvRoot } from '@tportal/common/utils';
import { User } from '@tportal/login/types';

interface SignInResponse {
  passwordAccepted: boolean;
  redirectUrl?: string;
}

const headers = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/json',
};

export const signIn = (user: User): Promise<SignInResponse> => (
  apiHelper.post(withEnvRoot('/users/sign_in'), { user }, { headers })
);
